// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2TBmD","actions":"GroupTable_actions__27Sx_","deleteModalFooter":"GroupTable_deleteModalFooter__3Xe-V"};